<template>
  <div class="cart">
    <!--    购物车头部-->
    <div class="cart-header">
      <i></i>
      <span class="cart-title">爱窝</span>
      <span class="cart-num">({{ shopCarNumber }})</span>
    </div>
    <!--购物车商品部分-->
    <div class="cart-card">
      <div class="cartCard-wrapper">
        <div v-for="(cardItem, index) in shopCardList" :key="cardItem.storeId">
          <div class="card-title">
            <div class="cardTitle-left">
              <i :class="[{ active: cardItem.choose }]" @click.prevent="chooseStore(cardItem.storeId, cardItem)"></i>
              <img :src="cardItem.storeLogo" alt />
              <span>{{ cardItem.storeName }}</span>
            </div>
            <div class="choose-buy" @click="continueBuy(cardItem.storeId)">继续选购</div>
          </div>
          <a class="sales-card" v-for="(salesitem, i) in cardItem.shopCarList" :key="salesitem.id">
            <i :class="[{ active: salesitem.choose }]" @click.prevent.stop="chooseSale(salesitem, salesitem.storeId)"></i>
            <img :src="salesitem.productImg" alt />
            <div class="sales-info">
              <p>
                {{ salesitem.productName }} &nbsp
                <span>{{ salesitem.productSpec }}</span>
              </p>
              <div class="salesInfo-price">
                ¥
                <span>{{ salesitem.productPrice }}</span>
                <span>/{{ salesitem.productUnit }}</span>
              </div>
              <div class="salesInfo-bottom">
                <span @click="show1 = true"></span>
                <p>
                  <span @click="addBtn('sub', salesitem)"></span>
                  <span class="input-count" @click.prevent="showUpdate(salesitem)">{{ salesitem.productNum }}</span>
                  <span @click="addBtn('add', salesitem)"></span>
                </p>
              </div>
            </div>
            <div class="overlay">
              <van-overlay :show="show1" :lock-scroll="true">
                <div class="wrapper" @click.stop>
                  <div class="block">
                    <p class="title">删除商品</p>
                    <p class="ipt">是否确认删除商品？</p>
                    <div class="confirm1" @click="delCardSales(salesitem.id)">
                      <p>确认</p>
                    </div>
                    <div class="cancel" @click="show1 = false">取消</div>
                  </div>
                </div>
              </van-overlay>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!--    底部提交订单-->
    <div class="submit-sales">
      <div class="submit-left">
        <i :class="[alLChoose ? 'active' : '']" @click.prevent="allChooseClick"></i>
        <span>全选</span>
      </div>
      <div class="submit-right">
        <span>共计：</span>
        <span>¥{{ Math.floor(chooseSalesPrice * 100) / 100 || 0 }}</span>
        <button @click="submitOrder">提交订单</button>
      </div>
    </div>
    <!--    再逛逛图标-->
    <router-link to="/homeclone" class="again-look" tag="div">再逛逛</router-link>
    <!--    修改商品数量-->
    <van-popup v-model="show">
      <div class="wrapper">
        <div class="block">
          <h1>修改数量</h1>
          <input type="number" oninput="if(value.length>4)value=value.slice(0,4)" v-model="salesNum" placeholder="请输入数量" />
          <button @click="showUpdate(1)">确认</button>
          <span @click="showUpdate">取消</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      show1: false,
      show: false,
      //购物车卡片选择框
      choose: false,
      //购物车列表
      shopCardList: [],
      //全选
      alLChoose: false,
      //选择的价格
      chooseSalesPrice: 0,
      //要修改数量的商品
      updateSalesNum: {},
      //修改的商品数量
      salesNum: 0,
      //商品件数
      goodstotalnum: 0,
      //爱窝数量
      shopCarNumber: 0,
      //记录商铺id的数组
      idArr: []
    }
  },
  methods: {
    ...mapActions(['setIsCart', 'setStoreId']),
    //展示修改数量框
    showUpdate(value) {
      this.show = !this.show
      //保存修改的产品
      if (typeof value === 'object' && 'storeId' in value) {
        this.updateSalesNum = value
        this.salesNum = value.productNum
      }
      //确认修改
      if (value === 1) {
        // console.log(this.updateSalesNum);
        this.shopCardList.forEach((storeItem) => {
          if (storeItem.storeId === this.updateSalesNum.storeId) {
            storeItem.shopCarList.forEach((item) => {
              if (item.productId === this.updateSalesNum.productId && item.id === this.updateSalesNum.id) {
                item.productNum = this.salesNum
                this.updateCardNum(item.productNum, item.id)
              }
            })
          }
        })
        this.choosePrice()
      }
    },
    //获取商品列表
    async getShopCardNum() {
      let userId = JSON.parse(localStorage.getItem('id'))
      let { data } = await this.$http.aPost(this.$api.getShopCarList, {
        userId
      })
      this.shopCardList = data.code === 0 && data.shopCarDtoList.reverse()
      this.shopCarNumber = data.shopCarNumber
      console.log('请求的数据', data)
      console.log(this.shopCardList)
    },
    //处理店铺选择
    chooseStore(id, item) {
      console.log('id', id)

      let arr = []
      this.shopCardList.forEach((storeItem) => {
        if (storeItem.storeId === id) {
          arr = storeItem.shopCarList.filter((saleItem) => saleItem.choose)
          // console.log('筛选单一商品:',arr);
          if (arr.length === storeItem.shopCarList.length) {
            this.$set(storeItem, 'choose', false)
            storeItem.shopCarList.forEach((item) => this.$set(item, 'choose', false))
            return
          }
          this.$set(storeItem, 'choose', true)
          storeItem.shopCarList.forEach((item) => {
            this.$set(item, 'choose', true)
          })
        }
      })
      console.log('item', item.choose)
      // if (item.choose === true) {
      //   this.idArr.push(id);
      //   console.log("idarr", this.idArr);
      // }else if(item.choose === false){
      //   let arrList = []
      //   for(let i = 0;i<this.idArr.length-1;i++){
      //     if(arrList.indexOf(this.idArr[i]) == -1){
      //       arrList.push(this.idArr[i])
      //     }
      //   }
      //   console.log('剩余的数组',arrList);

      //   console.log(1);

      // }
      this.beAllChoose()
      this.choosePrice()
    },
    //处理单一商品选择
    chooseSale(value, id) {
      console.log('value', value)
      console.log('id', id)
      // this.idArr.push(id);
      // console.log(value);
      this.$set(value, 'choose', !value.choose)
      let arr = []
      this.shopCardList.forEach((item) => {
        if (value.storeId === item.storeId) {
          arr = item.shopCarList.filter((saleItem) => saleItem.choose)
          arr.length === item.shopCarList.length ? this.$set(item, 'choose', true) : this.$set(item, 'choose', false)
        }
        this.beAllChoose()
      })
      this.choosePrice()
      // console.log(this.chooseSalesPrice);
    },
    //处理被动全选
    beAllChoose() {
      let arr = []
      arr = this.shopCardList.filter((saleItem) => saleItem.choose)
      if (arr.length === this.shopCardList.length) {
        this.alLChoose = true
        return
      }
      this.alLChoose = false
    },
    //单独处理全选点击
    allChooseClick() {
      // this.alLChoose=!this.alLChoose
      let arr = []
      console.log('asdasd', this.shopCardList)
      arr = this.shopCardList.filter((saleItem) => saleItem.choose)
      console.log('asdasdasdasdasd', arr)
      if (arr.length === this.shopCardList.length) {
        this.shopCardList.forEach((storeItem) => {
          this.$set(storeItem, 'choose', false)
          storeItem.shopCarList.forEach((item) => this.$set(item, 'choose', false))
        })
        this.alLChoose = false
        return
      }
      console.log('asdasdasasd', this.shopCardList)

      this.shopCardList.forEach((storeItem) => {
        this.$set(storeItem, 'choose', true)
        storeItem.shopCarList.forEach((item) => this.$set(item, 'choose', true))
      })
      this.alLChoose = true
      this.choosePrice()
      // console.log(this.chooseSalesPrice);
    },
    //处理选择的商品价格
    choosePrice() {
      let total = 0
      let num = 0
      this.shopCardList.forEach((storeItem) => {
        num = storeItem.shopCarList.reduce((preItem, nextItem) => {
          preItem += nextItem.choose ? Number(nextItem.productPrice) * Number(nextItem.productNum) : 0
          return preItem
        }, 0)
        total += num
      })
      this.chooseSalesPrice = total
    },
    //增加或减少数量
    addBtn(type, value) {
      if (type === 'sub') {
        if (value.productNum <= 1) return
        value.productNum > 1 && value.productNum--
      }
      if (type === 'add') {
        if (value.productNum >= 9999) return
        value.productNum < 9999 && value.productNum++
      }
      value.choose && this.choosePrice()
      this.updateCardNum(value.productNum, value.id)
    },
    //修改购物车产品数量到数据库
    async updateCardNum(num, shopCarId) {
      let { data } = await this.$http.aPost(this.$api.editShopCar, {
        num,
        shopCarId
      })
      data.code === 0 ? this.$toast('修改成功') : this.$toast('修改失败')
    },
    //删除购物车的产品
    async delCardSales(shopCarIds) {
      let { data } = await this.$http.aPost(this.$api.delShopCar, {
        shopCarIds
      })
      this.show1 = false
      data.code === 0 ? this.$toast('删除成功') : this.$toast('删除失败')
      //获取购物车列表
      await this.getShopCardNum()
    },
    //继续选购
    async continueBuy(storeId) {
      this.setIsCart(0)
      let { data } = await this.$http.aPost(this.$api.getHomePageStore, {
        storeId
      })
      if (data.code === 0) {
        let path = data.storeHomePage.storeIdentity === 2 ? '/AdvertisingBooth' : data.storeHomePage.storeIdentity === 1 ? '/userBooth' : ''
        // console.log('怎么可以:',path);
        await this.$router.push({ path: path, query: { storeId } })
      }
    },
    //提交订单
    async submitOrder() {
      // let checckArr = [];
      // for (var i in this.idArr) {
      //   if (checckArr.indexOf(this.idArr[i]) == -1) {
      //     checckArr.push(this.idArr[i]);
      //   }
      // }
      // console.log("筛选后的数组", checckArr);
      // if (checckArr.length > 1) {
      //   this.$toast("请选择单个商铺的商品");
      //   this.idArr = [];
      //   // this.choose=false
      //   // this.shopCarList = []
      //   // this.chooseSalesPrice=0
      //   return;
      // }
      console.log('shuzu1', this.shopCardList)

      let orderArr = []
      this.shopCardList.forEach((stroeItem) => (orderArr = [...orderArr, ...stroeItem.shopCarList]))
      var filterArr = orderArr.filter((item) => item.choose)
      console.log('222', filterArr)
      for (var i = 0; i < filterArr.length; i++) {
        let arr = []
        this.idArr.push(filterArr[i].storeId)
        console.log('storeID', arr)
      }
      console.log('baocun1d1', this.idArr)
      let checckArr = []
      for (var i in this.idArr) {
        if (checckArr.indexOf(this.idArr[i]) == -1) {
          checckArr.push(this.idArr[i])
        }
      }
      console.log('筛选后的数组', checckArr)
      if (checckArr.length > 1) {
        this.idArr = []
        this.$toast('请选择单个商铺的商品')
        console.log('有无清空', this.idArr)

        return
      }

      let id = filterArr.reduce((preItem, nextItem) => {
        return `${preItem},${nextItem.id}`
      }, '')
      if (id.length === 0) {
        this.$toast('请先选择商品')
        return
      }
      let obj = {
        shopCarIds: id.substr(1),
        userId: localStorage.getItem('id')
      }
      console.log('提交订单的参数', obj)
      let { data } = await this.$http.aPost(this.$api.saveShopCarPerOrder, obj)
      console.log('返回的信息', data)
      data.code === 0 && (await this.$router.push({ name: 'submitorder', params: { orderNum: data.msg } }))
    }
  },
  computed: {
    bmTab() {
      return this.$store.state.bmTab
    }
  },
  created() {
    this.setStoreId(JSON.parse(localStorage.getItem('storeId')))
    //底部导航持久化处理
    this.$store.state.bmTab = 2
    //获取购物车列表
    this.getShopCardNum()
  },
  mounted() {
    // this.aboutValuda();
  }
}
</script>
<style lang="scss">
@import '../../assets/mixin';
.cart {
  width: 100%;
  height: 95%;
  background: $bgcolor;
  margin-top: 2px;
  //头部
  .cart-header {
    width: 100%;
    height: 86px;
    padding: 30px 0 16px 32px;
    background-color: #ffffff;
    position: fixed;
    top: 54px;
    left: 0;
    i {
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url('../../assets/img/cart/cart.png') center center no-repeat;
      background-size: contain;
      vertical-align: -6px;
      margin-right: 16px;
    }
    span {
      display: inline-block;
      font-size: 34px;
      color: #dc6a2b;
      line-height: 34px;
      font-weight: bold;
    }
  }
  //购物车商品部分
  .cart-card {
    width: 100%;
    height: calc(100% - 142px - 196px);
    padding: 32px 24px;
    overflow: auto;
    position: fixed;
    bottom: 196px;
    left: 0;
    .cartCard-wrapper {
      width: 100%;
      background-color: $bgcolor;
      & > div {
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        margin-bottom: 32px;
        background-color: #ffffff;
        padding: 0 16px;
        //购物车商品头部
        .card-title {
          width: 100%;
          height: 104px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #dce4eb;
          .cardTitle-left {
            display: flex;
            align-items: center;
            i {
              width: 26px;
              height: 26px;
              display: inline-block;
              border: 1px solid #222222;
              border-radius: 50%;
              @include set-background('../../assets/img/cart/null.png');
              &.active {
                @include set-background('../../assets/img/cart/true.png');
              }
            }
            img {
              width: 40px;
              height: 40px;
              margin-left: 24px;
              margin-right: 10px;
              border-radius: 50%;
            }
            span {
              font-size: 28px;
              font-weight: bold;
              color: #222222;
            }
          }
          .choose-buy {
            font-size: 28px;
            font-weight: bold;
            color: #000000;
            margin-right: 28px;
          }
        }
        //购物车商品卡片
        .sales-card {
          width: 100%;
          display: flex;
          align-items: center;
          margin-top: 33px;
          background-color: #ffffff;
          padding-bottom: 33px;
          i {
            display: inline-block;
            width: 26px;
            height: 26px;
            border: 1px solid #222222;
            border-radius: 50%;
            @include set-background('../../assets/img/cart/null.png');
            &.active {
              @include set-background('../../assets/img/cart/true.png');
            }
          }
          img {
            width: 180px;
            height: 180px;
            border-radius: 10px;
            margin-left: 23px;
            margin-right: 24px;
          }
          .sales-info {
            flex: 1;
            height: 180px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p {
              color: #222222;
              font-size: 32px;
              font-weight: bold;
              line-height: 39px;
              span {
                font-size: 28px;
                color: #999999;
                margin-left: 2px;
              }
            }
            .salesInfo-price {
              font-size: 28px;
              span {
                &:first-child {
                  font-size: 32px;
                  color: #222222;
                  font-weight: bold;
                  margin-left: 1px;
                }
                &:last-child {
                  font-size: 28px;
                  color: #999999;
                  margin-left: 2px;
                }
              }
            }
            .salesInfo-bottom {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              & > span {
                display: inline-block;
                width: 64px;
                height: 40px;
                background: url('../../assets/img/cart/del.png') left center no-repeat;
                background-size: contain;
                border-right: 1px solid #596d8d;
                //@include set-background('../../assets/img/cart/del.png')
              }
              & > p {
                margin-left: 24px;
                @include flex(center, center);
                span {
                  display: inline-block;
                  width: 59px;
                  height: 41px;
                  &:first-child {
                    @include set-background('../../assets/img/cart/sub.png');
                  }
                  &:last-child {
                    @include set-background('../../assets/img/cart/add.png');
                  }
                }
                .input-count {
                  background: #f0f4f7;
                  border-radius: 10px;
                  text-align: center;
                  width: 121px;
                  height: 40px;
                  margin: 0 7px;
                  font-size: 28px;
                  color: #999999;
                  line-height: 40px;
                }
              }
            }
          }
          /*删除弹窗*/
          .overlay {
            .wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              background: #222;
            }
            .block {
              width: 540px;
              // height: 404px;
              background: #ffffff;
              opacity: 1;
              border-radius: 20px;
              .title {
                width: 100%;
                text-align: center;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #000000;
                margin-top: 40px;
              }
              .ipt {
                // width: 100%;
                margin-top: 48px;
                margin-left: 40px;
                width: 460px;
                height: 80px;
                // border: 1px solid #DCE4EB;
                opacity: 1;
                border-radius: 10px;
                padding-left: 20px;
                input {
                  width: 100%;
                  height: 100%;
                  font-size: 32px;
                  border: 1px solid #dce4eb;
                }
              }
              .join {
                margin-top: 48px;
                margin-left: 40px;
                width: 460px;
                height: 80px;
                border: 1px solid #dce4eb;
                opacity: 1;
                border-radius: 10px;
                padding-left: 20px;
                display: flex;
                font-size: 34px;
                // align-items: center;
                justify-content: center;
                font-family: Source Han Sans CN;
                font-weight: bold;
              }
              .confirm1 {
                width: 460px;
                height: 80px;
                background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
                opacity: 1;
                border-radius: 40px;
                margin-top: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
              }
              .confirm {
                width: 460px;
                height: 80px;
                background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
                opacity: 1;
                border-radius: 40px;
                margin-top: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
              }
              .cancel {
                width: 100%;
                text-align: center;
                font-size: 30px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #909397;
                margin-top: 32px;
                padding-bottom: 32px;
              }
            }
          }
        }
      }
    }
  }
  // 底部提交订单
  .submit-sales {
    width: 100%;
    height: 96px;
    @include flex($between);
    background-color: #ffffff;
    position: fixed;
    bottom: 100px;
    left: 0;
    padding: 0 38px;
    .submit-left {
      color: #999999;
      font-size: 28px;
      i {
        display: inline-block;
        width: 26px;
        height: 26px;
        border: 1px solid #222222;
        border-radius: 50%;
        @include set-background('../../assets/img/cart/null.png');
        &.active {
          @include set-background('../../assets/img/cart/true.png');
        }
      }
      /*input{
            vertical-align:bottom;
          }*/
    }
    .submit-right {
      @include flex($start);
      button {
        width: 168px;
        height: 62px;
        background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
        opacity: 1;
        border-radius: 40px;
        font-size: 30px;
        color: #ffffff;
        font-weight: 500;
        margin-left: 19px;
        border: none;
        outline: none;
      }
      span {
        display: inline-block;
        line-height: 28px;
        font-size: 28px;
        &:first-child {
          color: #999999;
        }
      }
    }
  }
  //在逛逛按钮
  .again-look {
    width: 100px;
    height: 100px;
    background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
    border-radius: 50%;
    line-height: 100px;
    white-space: nowrap;
    //padding: 0 10px;
    text-align: center;
    color: #ffffff;
    position: fixed;
    right: 20px;
    bottom: 350px;
    //box-sizing: border-box;
  }
  //遮罩层
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 540px;
    height: 440px;
    background-color: #fff;
    border-radius: 20px;
    @include flex($between, center, $column);
    padding: 40px 41px 32px 41px;
    h1 {
      color: #000000;
      line-height: 54px;
      font-weight: bold;
      font-size: 32px;
    }
    input {
      width: 460px;
      height: 80px;
      border: 1px solid #dce4eb;
      padding-left: 14px;
      font-size: 32px;
      &::placeholder {
        color: #909397;
      }
    }
    button {
      border: none;
      outline: none;
      @include hj-button(100%, 80px, 32px);
    }
    span {
      font-size: 30px;
      color: #909397;
    }
  }
}
</style>
<style scoped lang="scss">
.van-dialog {
  width: 540px;
  height: 404px;
  background-color: yellow;
  .van-dialog--round-button {
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cart/cart.vue